import PropTypes from 'prop-types';
import React from 'react';
import content from '../../locales/en/content.json';
import { getPlannedClinic } from '../../utils/helpers';

const FacilityReview = ({ data, goToPath }) => {
  const {
    userSelected: selectedFacility,
    caregiverSupport: selectedCaregiverSupportFacility,
  } = getPlannedClinic(data);

  const hasAssignedFacility =
    selectedFacility?.id !== selectedCaregiverSupportFacility?.id;

  const handleEditClick = () =>
    goToPath('/veteran-information/va-medical-center/locator?review=true');

  return (
    <div className="form-review-panel-page">
      <form className="rjsf" noValidate="">
        <div className="form-review-panel-page-header-row">
          <h3 className="form-review-panel-page-header vads-u-font-size--h5">
            {content['vet-med-center-search-description']}
          </h3>
          <va-button
            text={content['button-edit']}
            label={content['facilities-review--edit-aria-label']}
            onClick={handleEditClick}
            secondary
          />
        </div>
        <dl className="review">
          <div className="review-row">
            <dt>{content['facilities-review--selected-row-title']}</dt>
            <dd>{selectedFacility.name}</dd>
          </div>
          {hasAssignedFacility && (
            <div className="review-row">
              <dt>{content['facilities-review--assigned-row-title']}</dt>
              <dd>{selectedCaregiverSupportFacility.name}</dd>
            </div>
          )}
        </dl>
      </form>
    </div>
  );
};

FacilityReview.propTypes = {
  data: PropTypes.object,
  goToPath: PropTypes.func,
};

export default FacilityReview;
